import { render } from "./SubTask.vue?vue&type=template&id=95fe801e&scoped=true"
import script from "./SubTask.vue?vue&type=script&lang=js"
export * from "./SubTask.vue?vue&type=script&lang=js"

import "./SubTask.vue?vue&type=style&index=0&id=95fe801e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95fe801e"]])

export default __exports__